import { MemberContactEmailAddressEntity, MemberContactPhoneNumberEntity, MemberContactRoleEntity } from '.';
import { ContactType } from '../../types';
import { PendingEntity } from '../PendingEntity';

export class MemberContactEntity extends PendingEntity {
  firstName: string;
  lastName: string;
  department_En: string;
  department_Fr: string;
  isVisibleToMember: boolean;
  hasEcommerceAccess: boolean;
  type: ContactType;
  roleId: number | null;
  role: MemberContactRoleEntity | null;
  emailAddresses: MemberContactEmailAddressEntity[];
  phoneNumbers: MemberContactPhoneNumberEntity[];
  isArchived: boolean;
  mailSyncError: string;
  mailSyncDate: Date;
  distributionCenter: number | null;

  constructor(entity?: MemberContactEntity) {
    super(entity);
    if (entity) {
      Object.assign(this, { ...entity });
      this.distributionCenter =
        typeof entity['distributionCenter'] === 'number'
          ? entity['distributionCenter']
          : (entity['distributionCenter'] as { id: number } | null)?.id ?? null;
    } else {
      this.firstName = '';
      this.lastName = '';
      this.department_En = '';
      this.department_Fr = '';
      this.isVisibleToMember = false;
      this.hasEcommerceAccess = false;
      this.type = ContactType.Person;
      this.roleId = null;
      this.role = null;
      this.emailAddresses = [];
      this.phoneNumbers = [];
      this.distributionCenter = null;
    }
  }
}
